<snackbar [configuration]="config" (snackbarDismissed)="dismiss.emit()"></snackbar>
